module.exports = __webpack_public_path__ + "img/plus-icon.b9780849.svg";